export const pl = {
  message: {
    dashboard: {
      messages: 'Wiadomości',
      messagesNew: '{count} nowa | {count} nowe',
      messagesProjects: 'Projekty: {count}',
      edit: 'Edytuj',
      done: 'Gotowe',
      reset: 'Resetuj',
      theme: 'Motyw',
      darkMode: 'Tryb ciemny',
      featured: 'Wyróżnione',
      allModules: 'Wszystkie moduły',
      dragToFeature: 'Przeciągnij moduły tutaj, aby je wyróżnić',
      editHint: 'Przeciągnij, aby zmienić kolejność · zmiany zapisują się automatycznie',
      editHintFeatured: 'Przeciągnij moduł w górę, aby go wyróżnić · przeciągnij w dół, aby usunąć',
      editHintBento: 'Przeciągnij, aby zmienić kolejność · dotknij ⤢, aby zmienić rozmiar · zapisywane automatycznie',
      layoutTiles: 'Kafelki',
      layoutSections: 'Sekcje',
      layoutBento: 'Bento',
      sectionWork: 'Praca',
      sectionResources: 'Zasoby',
      sectionInfoMore: 'Informacje i więcej',
      modules: 'Moduły',
      customizeModules: 'Dostosuj moduły'
    },
    layout: {
      login: 'Zaloguj się',
      logout: 'Wyloguj się',
      rfidsignin: 'Zaloguj się za pomocą RFID',
      SignInpassword: 'Zaloguj się hasłem',
      ScanRFID: 'Zeskanuj swój znacznik RFID',
      ortext: 'LUB',
      // dashboard: 'Tablica rozdzielcza',
      dashboard: 'panel',
      timer: 'Timer',
      projects: 'Projekty',
      stemp: 'Zestaw stempla',
      calendar: 'Kalendarz',
      deviation: 'Rozkład',
      home: 'Strona główna',
      deliver: 'Dostarcz',
      more: 'Więcej',
      files: 'Dokumenty',
      equipments: 'Wyposażenie',
      checklists: 'Listy kontrolne',
      drawing: 'Rysunek',
      pressureTestReport: 'Raport z próby ciśnieniowej',
      weldlog: 'Dziennik spawania',
      event: 'wydarzenie',
      ndt: 'NDT',
      surfaceReport: 'Raport o powierzchni',
      technicalReport: 'Raport techniczny',
      matrialList: 'Lista matryc',
      pwht: 'PWHT',
      pwps: 'PWPS',
      wps: 'WPS',
      warehouse: 'Magazyn',
      tasks: 'Zadania',
      orders: 'Zamówienia',
      facilities: 'Obiekt',
      chemicallist: 'Rejestr substancji',
      nbselftL: '',
      asbuilt: 'Zbudowany jako',
      autoLogout: 'automatyczne wylogowanie'
    },
    login: {
      language: 'Język',
      back: 'Powrót',
      userName: 'Nazwa użytkownika',
      password: 'Hasło',
      authFailed: 'Autentykacja nie powiodła się !',
      networkError: 'Nie można połączyć się z serwerem. Sprawdź połączenie i nazwę hosta.',
      invalidCredentials: 'Błędna nazwa użytkownika lub hasło !',
      serverError: 'Serwer nie mógł ukończyć logowania. Skontaktuj się z pomocą techniczną.',
      host: 'Host',
      forgotPassword: 'Zapomniałeś hasła?',
      forgotPasswordHint: 'Wprowadź swój adres e-mail poniżej, aby zresetować hasło.',
      backToLogin: 'Powrót do logowania',
      emailAddress: 'Adres e-mail',
      resetMyPassword: 'Zresetuj moje hasło'
    },
    common: {
      pwaNotEnabled: 'PWA nie jest włączone, skontaktuj się z administratorem',
      delete_row: 'Usuń wiersz',
      install: 'Zainstaluj tę aplikację na swoim ekranie głównym, aby mieć do niej szybki i łatwy dostęp, gdy jesteś w ruchu.',
      justTab: 'Po prostu dotknij',
      addToHome: 'następnie "Dodaj do ekranu głównego".',
      english: 'Angielski',
      norwegian: 'Norweski',
      lithuanian: 'Litewski',
      polish: 'Polski',
      swedish: 'Szwedzki',
      save: 'Zapisz',
      saveAndClose: 'Zapisz i zamknij',
      send: 'Wyślij',
      edit: 'Edytuj',
      cancel: 'Anuluj',
      update: 'Aktualizacja',
      delete: 'Usuń',
      updateAndClose: 'Zaktualizuj i zamknij',
      close: 'Zamknij',
      new: 'Nowa strona',
      isActive: 'Jest aktywny',
      addNew: 'Dodaj nowy',
      savedSuccess: 'Zapisano pomyślnie!',
      addedSucess: 'Dodane pomyślnie !',
      updatedSuccess: 'Zaktualizowano pomyślnie !',
      deleteSuccess: 'Usunięto pomyślnie !',
      errorOccured: 'Wystąpił błąd !',
      backToList: 'Powrót do listy',
      search: 'Szukaj',
      yes: 'Tak',
      no: 'Nie',
      isDefault: 'Jest domyślna',
      loadingMsg: 'Ładowanie, proszę czekać',
      deleteConfirm: 'Usuń Potwierdź',
      areYouSure: 'Czy na pewno chcesz usunąć?',
      validationIssue: 'Proszę sprawdzić wymagane pola!',
      total: 'Całkowity',
      noResults: 'Nie znaleziono żadnych wyników !',
      statusUpdateFailed: 'Status nie został zapisany. Spróbuj ponownie.',
      increaseHeight: 'Zwiększ wysokość',
      decreaseHeight: 'Zmniejsz wysokość',
      others: 'Inne',
      typeHere: 'Wpisz tutaj...',
      position: 'Pozycja',
      color: 'Kolor',
      maxCharacters: 'Max {charCount} znaków',
      changedPassword: 'Hasło zostało zmienione pomyślnie',
      import: 'Import',
      note: 'Notatka',
      invalidEmail: 'Nieprawidłowy e-mail',
      no_records: 'Nie znaleziono żadnych rekordów!',
      no_data: 'Brak dostępnych danych',
      ok: 'Ok',
      date: 'Data',
      comments: 'Komentarze',
      draftMsg: 'Zapisane jako wersja robocza',
      createProjectRole: 'Utwórz rolę projektu',
      updateProjectRole: 'Aktualizuj rolę projektową',
      module: 'Moduł',
      selectTemplate: 'Wybierz szablon',
      documentTemplate: 'Szablon dokumentu',
      download: 'Pobierz',
      uploadedSuccess: 'Załadowano pomyślnie!',
      weekTotalHours: 'Tydzień godz.',
      addWorktype: 'Dodaj typ pracy',
      updateWorktype: 'Aktualizuj typ pracy',
      worktype: 'Typ pracy',
      newUpdate: 'Nowa aktualizacja dostępna!',
      discardChangesAndUpdate: 'Masz niezapisane zmiany. Odrzucić je i zaktualizować?',
      updateAfterSave: 'Dostępna jest nowsza wersja. Zapisz swoją pracę, a aplikacja się zaktualizuje.',
      refresh: 'Odśwież',
      retry: 'Spróbuj ponownie',
      somethingWentWrong: 'Coś poszło nie tak',
      online: 'Połączono',
      offline: 'Offline',
      moduleName: 'Nazwa modułu',
      updatedOn: 'Zaktualizowano na',
      columns: 'Kolumny',
      confirmCancel: 'Potwierdź anulowanie',
      areYouSureCancel: 'Czy na pewno chcesz anulować?',
      not_approved_notification: 'Cześć! {count} rejestracja(y) czasu w tygodniu {weeknumber} nie jest zatwierdzona.',
      hourExceedNotification: 'Zarejestrowane godziny przekraczają 24 godziny.',
      options: 'Opcje',
      label: 'Etykieta',
      value: 'Wartość',
      confirmStatusChange: 'Potwierdź zmianę statusu',
      areYouSureToChangeStatus: 'Czy na pewno chcesz zmienić status na {statusText} ?',
      complete: 'kompletny',
      incomplete: 'niekompletny',
      name: 'Nazwa',
      number: 'Numer',
      noPermission: 'Przepraszamy! Nie masz uprawnień do {permissionType} {module}.',
      charsLimit35: 'Proszę wpisać nie więcej niż {length} znaków',
      confirmAddHour: 'Zmiana została zakończona!',
      sureToAddExceedingHour: 'Wprowadzona godzina przekracza godziny pracy, czy na pewno chcesz dodać ?',
      warning: 'Ostrzeżenie',
      required: 'Wymagane',
      timerFeatureDisabled: 'Funkcja timera wyłączona',
      locationNotSet: 'Nie ustawiono lokalizacji',
      type: 'Rodzaj',
      changeVideoSource: 'Zmień źródło wideo',
      permissionDenied: 'Zezwolenie na kamerę jest zablokowane!, proszę włączyć je w ustawieniach przeglądarki!',
      time: 'Czas',
      orderno: 'Nr zamówienia',
      ready_for_production: 'Gotowe do produkcji',
      production: 'Produkcja',
      on_hold: 'Wstrzymane',
      finished: 'Zakończone',
      of: 'z',
      ndt_percentage_error: 'Procent NDT musi wynosić od 0 do 100',
      lengthError: 'Długość musi być mniejsza niż 10',
      update_properties: 'Zaktualizuj właściwości',
      add_properties: 'Dodaj właściwości',
      preparing_fields: 'Przygotowanie pól...',
      from_attributs: 'ATRYBUTY FORMULARZA',
      enter_title: 'Wprowadź tytuł każdej kolumny:',
      loading_grid: 'Wczytywanie siatek...',
      from_properties: 'WŁAŚCIWOŚCI FORMULARZA',
      dragging: 'Włóka...',
      catch_up: 'Wszystko zajęte!!!',
      add_header: 'Dodaj nagłówek',
      add_footer: 'Dodaj stopkę',
      drop_fields: 'Upuść pola tutaj',
      for_header: 'DLA NAGŁÓWKA',
      for_footer: 'DLA STOPKI',
      add_html: 'DODAJ TREŚĆ HTML',
      relate: 'Odnosić się',
      unrelate: 'Niezwiązane',
      values: 'Wartości',
      scan: 'Skanowanie',
      filename: 'Nazwa pliku',
      fitToScreen: 'Dopasuj do ekranu',
      actualSize: 'Rozmiar rzeczywisty',
      zoomIn: 'Powiększ',
      zoomOut: 'Pomniejsz',
      reset: 'Resetowanie',
      doYouWantContinue: 'Nadal chcesz kontynuować?',
      stempHint: 'Jeśli wybierzesz Shift, możesz rozpocząć stempel',
      hoursExeed: 'przekraczający 24 godziny',
      on: 'Na',
      reachedHours: 'Osiągnięto 24 godziny',
      invaliHours: 'Nieprawidłowe godziny',
      notValidNumber: 'Nieprawidłowy numer',
      invalidName: 'Błędna nazwa',
      filterSaveResult: 'Wyszukiwanie pozwala zobaczyć zastosowany filtr, a przefiltrowany wynik można zobaczyć w raporcie tylko po zapisaniu listy kontrolnej',
      seemsInvalid: 'Wydaje się, że godziny są nieprawidłowe!',
      shiftContinue: 'Twoja godzina stempla trwa...',
      no_fields_found: 'Nie znaleziono pól listy kontrolnej',
      sharePoint: 'Sharepoint może mieć nieprawidłowe poświadczenia lub brakuje konfiguracji!',
      dragAndDropTips: 'Zapisywanie jest obowiązkowe przy każdym przeciąganiu i upuszczaniu, aby uniknąć błędnego rozmieszczenia wierszy',
      afterCopyFilter: 'Akcja filtrowania będzie wykonywana do momentu zapisania listy kontrolnej',
      archived: 'Zarchiwizowane',
      datagrid_filter_help_text_1: 'Wyniki będą filtrowane tak samo, jak opcje filtrowania ostatniego razu.',
      datagrid_filter_help_text_2: 'Po dodaniu nowego wiersza filtry zostaną usunięte, a wszystkie wiersze zostaną dodane.',
      datagrid_filter_help_text_3: 'Filtry nie rozróżniają wielkości liter, więc możemy używać zarówno wielkich, jak i małych liter.',
      datagrid_filter_help_text_4: 'Nie możemy dwukrotnie filtrować tej samej kolumny.',
      datagrid_filter_help_text_5: 'Przeciągnij i upuść zostanie zmodyfikowany według wyniku filtra, jeśli użytkownik zapisze listę kontrolną.',
      datagrid_filter_help_text_6: 'Obszar tekstowy filtrowany według słowa pomiędzy dowolną częścią zdania.',
      datagrid_filter_help_text_7: 'Obowiązkowe jest wypełnienie zarówno pola, jak i jego wartości, aby wykonać akcję filtrowania.',
      sharepointCharacters: "To pole nie powinno zawierać żadnego z tych znaków '*:<>?/\\|.'",
      filenotfound: 'Plik nie znaleziony',
      folder: 'Folder',
      folders: 'Foldery',
      files: 'Pliki',
      emptyFolder: 'Ten folder jest pusty',
      emptyFolderHint: 'Opublikowane dokumenty pojawią się tutaj',
      gridView: 'Widok siatki',
      listView: 'Widok listy',
      back: 'Wstecz',
      searchResults: 'Wyniki wyszukiwania',
      previousDocument: 'Poprzedni dokument',
      nextDocument: 'Następny dokument',
      imagedraw: 'Rysowanie na obrazie'
    },
    timer: {
      stop: 'Zatrzymaj',
      ga_til_time: 'Przejdź do listy godzin',
      minutes: 'minut',
      start: 'Start',
      place: 'Miejsce',
      hours: 'Godziny',
      activity: 'Działanie',
      inactive_suffix: '(nieaktywny)',
      not_linked_warning: 'Ten wpis nie zostanie przeniesiony do {integration} — coś nie jest połączone',
      pause: 'Pauza',
      from: 'Od',
      till: 'Do',
      shift: 'Lista zmian',
      startTime: 'Czas rozpoczęcia',
      endTime: 'Czas końcowy',
      editHours: 'Edytuj Godzinę',
      approved: 'Zatwierdzono',
      notApproved: 'Nie zatwierdzony',
      delivered: 'Dostarczono',
      notDelivered: 'Nie dostarczono',
      year: 'Rok',
      week: 'Tydzień',
      nonBillable: 'Urlop / Nieobecność',
      hourlogging: 'Hourlogging',
      noHours: 'Nie znaleziono godzin dla dostawy !',
      deliveredMsg: 'Dostarczono pomyślnie',
      addHours: 'Dodaj godzinę',
      deliverHours: 'Dostarczono godziny',
      hoursExceeding: 'Timer przekroczył 8 godzin',
      cancelTimer: 'Anuluj Timer',
      uploadSuccess: 'Prześlij pomyślnie',
      picture: 'Zrób zdjęcie',
      imageNeeded: 'Proszę załadować zdjęcie przed zatrzymaniem timera!',
      nonbillableworktype: 'Rodzaj urlopu / nieobecności',
      additionalWorktype: 'Dodatkowy typ pracy',
      additional_hours: 'Dodatkowe godziny',
      select: 'Wybierz',
      check_field: 'Sprawdź to pole',
      check_fields: 'Sprawdź: {fields}',
      inactive_work_type: 'Wybrany typ pracy jest nieaktywny. Wybierz inny.',
      inactive_activity: 'Wybrana czynność jest nieaktywna. Wybierz inną.',
      additional_hours_positive: 'Dodatkowe godziny muszą być większe niż 0',
      additional_hours_exceed: 'Dodatkowe godziny nie mogą przekraczać przepracowanych godzin ({hours})',
      switchProject: 'Zmień projekt',
      reasonForSwitchingProject: 'Powód zmiany projektu',
      projectSwitchedSuccessfully: 'Projekt został pomyślnie zmieniony',
      failedToSwitchProject: 'Nie można przełączyć projektu',
      selectDifferentProject: 'Wybierz inny projekt'
    },
    projects: {
      chatOpen: 'Otwórz',
      chatEditMembers: 'Edytuj uczestników',
      chatEditMembersHint: 'Zaznacz, kto ma być w rozmowie. Dodana osoba zobaczy całą historię.',
      chatCreate: 'Utwórz',
      chatParticipants: 'Uczestnicy',
      chatNewPrivate: '+ Nowy',
      chatSend: 'Wyślij',
      chatPrivate: 'Prywatny',
      chatSeenBy: 'Widziane przez {count}',
      chatSent: 'Wysłano',
      chatEveryone: '{count} uczestników · wszyscy z dostępem do projektu',
      chatPrivateOnly: 'Tylko {names} widzi tę rozmowę',
      chatNewPrivateTitle: 'Nowa prywatna rozmowa',
      chatNewPrivateHint: 'Wybierz, kto może widzieć tę rozmowę.',
      chat: 'Czat',
      chatConversations: 'Rozmowy',
      chatEmpty: 'Brak wiadomości.',
      chatPlaceholder: 'Napisz wiadomość...',
      chatOpenWeldMapping: 'Open weld mapping',
      chatYou: 'ty',
      chatEdited: 'edytowano',
      chatConfirmDelete: 'Usunąć tę wiadomość?',
      chatToday: 'Dzisiaj',
      chatYesterday: 'Wczoraj',
      startDate: 'Data rozpoczęcia',
      endDate: 'Data końcowa',
      projectNo: 'Nr projektu',
      projectname: 'Nazwa projektu',
      aoRanked: 'AO Ranked',
      workOrderName: 'Nazwa zlecenia',
      all: 'Wszystkie',
      allActive: 'Wszystkie Aktywne',
      myAll: 'Moje wszystkie',
      myActive: 'Mój Aktywny',
      project: 'Projekt',
      customer: 'Klient',
      status: 'Status',
      noActiveProjects: 'Brak aktywnych projektów!',
      selectProject: 'Wybierz projekt',
      projectMaterialDisabled: 'Materiały wyłączone dla tego projektu',
      drawingGroup: 'Grupa rysunkowa',
      allDrawingGroups: 'Wszystkie grupy',
      sectionIdentification: 'Identyfikacja',
      sectionStatusAttachments: 'Status i załączniki',
      sectionReportDetails: 'Szczegóły raportu',
      sectionWelding: 'Spawanie',
      sectionMaterials: 'Materiały',
      sectionInspection: 'Kontrola (NDT)'
    },
    calendar: {
      today: 'Dzisiaj',
      month: 'Miesiąc',
      day: 'Dzień',
      weekNotExists: 'Tydzień nie istnieje',
      yearValid: 'Musi składać się z czterech cyfr',
      valid: 'Musi być ważny',
      yearTooLessValidation: 'Rok musi być większy niż 1920',
      weekLock: 'Wybrane daty znajdują się w zablokowanym tygodniu',
      dayLocked: 'Wybrana data znajduje się w zablokowanym tygodniu',
      otherHourEntries: 'Inne wpisy godzinowe'
    },
    shifts: {
      shift: 'Moje zmiany',
      documents: 'Dokumenty:',
      not_found: 'Nie znaleziono opisu i adresu url.',
      notValidPausedTime: 'Czas pauzy jest dłuższy niż czas zmiany',
      continue: 'Kontynuować',
      clear: 'Jasne'
    },
    deviation: {
      deviations: 'Odchylenie',
      register_deviation: 'Odchylenie rejestru',
      view_deviation: 'Zobacz odchylenie',
      high: 'Wysokie',
      medium: 'Średnie',
      low: 'Niskie',
      closed: 'Zamknięta',
      registered: 'Zarejestrowane',
      process: 'Proces',
      actions: 'Działania',
      title: 'Tytuł',
      reported_by: 'Zgłoszone przez',
      location: 'Lokalizacja',
      reason: 'Powód',
      document: 'Dokument',
      category: 'Kategoria',
      estimate_cost: 'Szacunkowy koszt',
      severity: 'Waga',
      deviation_status: 'Status odchylenia',
      deadline: 'Termin realizacji',
      description: 'Opis',
      responsible: 'Odpowiedzialny',
      copyto: 'Kopia Do',
      upload_files: 'Prześlij',
      required_message: 'To pole jest wymagane',
      consequences: 'Konsekwencje',
      changeRequest: 'Żądanie zmiany',
      hse: 'BHP',
      deviation_number: 'Numer odchylenia',
      underlying_reason: 'Przyczyna źródłowa',
      corrective_actions: 'Działania korygujące',
      effect_of_measures: 'Efekt działań',
      sectionRegistration: 'Rejestracja',
      sectionClassification: 'Klasyfikacja',
      sectionFollowUp: 'Działania następcze',
      sectionWhatHappened: 'Co się wydarzyło',
      sectionCorrectiveAction: 'Działanie korygujące',
      sectionAttachments: 'Załączniki',
      readonlyNotice: 'Nie masz uprawnień do edycji tego odchylenia. Pola są wyświetlane wyłącznie w celach informacyjnych.'
    },
    checklist: {
      title: 'Lista kontrolna',
      updateChecklist: 'Aktualizacja listy kontrolnej',
      pickCheckList: 'Wybierz listę kontrolną',
      addCheckList: 'Dodaj listę kontrolną',
      hmsKs: 'HMS/KS',
      templateName: 'Nazwa szablonu',
      checklist_recipients: 'Odbiorca emaila',
      checklist_recipient_hint: 'Wpisz adres e-mail oddzielony przecinkami (,).',
      projectnr: 'PO Nr.',
      projectname: 'Nazwa Projektu',
      aonr: 'AO Nr.',
      workordername: 'Nazwa zlecenia pracy',
      customer: 'Klient',
      customercontact: 'Kontakt z klientem',
      projectleader: 'Lider Projektu',
      importCSV: 'Importuj CSV',
      CSVFileInfo: 'Tutaj możesz zaimportować dane z pliku csv do listy kontrolnej.',
      removeRow: 'Usuń 1. wiersz, jeśli zawiera nagłówki.',
      sameOrederColumn: 'Upewnij się, że kolumny są w tej samej kolejności, w jakiej zdefiniowano je na liście kontrolnej.',
      semicolonDelimiter: 'Użyj średnika jako separatora csv.',
      withoutImport: 'Bez importu',
      addCSVFile: 'Dodaj plik CSV',
      report_header: 'Nagłówek raportu',
      copy_confirm: 'Czy chcesz skopiować listę kontrolną?',
      filter: 'Filtr',
      apply: 'Stosować',
      image: 'Obraz',
      no_comment: 'Brak komentarza',
      action: 'Działanie',
      cameraCapture: 'Uchwyć zdjęcie',
      openCamera: 'Otwórz kamerę',
      takePhoto: 'Zrób zdjęcie',
      uploadDocument: 'Otwórz kamerę i prześlij dokument',
      retake: 'Zrób ponownie'
    },
    equipments: {
      equipment: 'Wyposażenie',
      addEquipment: 'Dodaj wyposażenie',
      updateEquipment: 'Zaktualizuj wyposażenie',
      viewEquipment: 'Zobacz wyposażenie',
      active: 'Aktywny',
      quarantine: 'Kwarantanna',
      discarded: 'Odrzucony',
      warrantydate: 'Data gwarancji',
      dateofPurchase: 'Data zakupu',
      vendor: 'Sprzedawca',
      modelNumber: 'Numer modelu',
      product: 'Produkt',
      serialNumber: 'Numer seryjny',
      capacity: 'Pojemność',
      groups: 'Grupy',
      plannedCalibration: 'Planowana kalibracja',
      scrapDate: 'Data złomowania',
      equipmentNumber: 'Numer urządzenia',
      placement: 'Umieszczenie',
      notifyByEmail: 'Powiadomienie przez e-mail',
      mustAllocateToProjectOrLocation: 'Musi przypisać sprzęt do projektu lub lokalizacji.',
      confirm: 'Jesteś pewny?',
      company: 'Firma'
    },
    customModule: {
      modules: 'Moduły',
      customModule: 'Moduł niestandardowy',
      customModules: 'Moduły niestandardowe',
      uploadDocument: 'Prześlij dokument',
      isCompleted: 'Jest zakończony',
      add: 'Dodaj',
      urlNotFound: 'Nie znaleziono adresu url do pobrania',
      completed: 'Ukończono',
      notCompleted: 'Nie ukończono',
      fileSizeLimitMsg: 'Przekroczono limit rozmiaru pliku dla jednego lub więcej plików (Max.Limit {maxSize}MB).',
      invalidFileType: 'Niedozwolony typ pliku'
    },
    moduleReports: {
      title: 'Raporty modułów',
      chartyAxis: 'Liczba rekordów (na moduł)'
    },
    projectFeature: {
      drawingNumber: 'Nr rysunku',
      poRanked: 'PO Ranga',
      operator: 'Operator',
      reportNumber: 'Nr raportu',
      uploadNdtDocument: 'Załaduj dokument NDT',
      aoRanked: 'Ranking AO',
      NDTSpecifications: 'Specyfikacja badań nieniszczących',
      NDTScope: 'Zakres badań nieniszczących',
      filterMaterials: 'Materiały filtracyjne',
      chargedLotNumber: 'Nr kartki/działki',
      selectFiles: 'Wybierz pliki',
      createdOn: 'Utworzono dnia',
      weldingID: 'ID spawania',
      weldNumber: 'Numer spoiny',
      wpsNumber: 'Nr WPS.',
      wpsAsComma: 'Wprowadź numer WPS oddzielony przecinkami.',
      weldEnd: 'Koniec spoiny',
      vtSignDate: 'VT Znak./Data',
      rtSignDate: 'RT Znak./Data',
      utSignDate: 'UT Znak./Data',
      mtPtSignDate: 'MT/PT Znak./Data',
      createdDate: 'Data utworzenia',
      tegNr: 'Teg nr.',
      tegNrWpsNr: 'Teg nr. / Wps nr.',
      posNr: 'Nr poz.',
      batchNr: 'Nr partii',
      heatNr: 'Nr kat.',
      onStock: 'Na stanie',
      weldingConsumable: 'Materiał spawalniczy',
      registerBatchAgainstWps: 'Zarejestruj nr partii względem WPS, do dziennika spawania',
      out: 'Wydanie',
      sectionIdentification: 'Identyfikacja',
      sectionStock: 'Magazyn',
      sectionStatus: 'Status i załączniki',
      descriptionHint: 'Opis',
      recordNumber: 'Numer zapisu',
      chartSpeed: 'Prędkość wykresu',
      chartNumber: 'Numer wykresu',
      unrestrictedTo: 'Bez ograniczeń Do',
      restrictedRateOfRise: 'Ograniczona Szybkość narastania',
      holdTemperatureRequired: 'Wymagana temperatura podtrzymania',
      holdTemperatureActual: 'Rzeczywista temperatura podtrzymania',
      holdTimeActual: 'Rzeczywisty czas podtrzymania',
      holdTimeRequired: 'Wymagany czas podtrzymania',
      restrictedRateDown: 'Ograniczona szybkość opadania',
      unrestrictedRateOfFall: 'Nieograniczona prędkość opadania',
      weldDate: 'Data spawania',
      performedBy: 'Wykonane przez',
      approvedBy: 'Zatwierdzony przez',
      approvedDate: 'Zatwierdzona data',
      weldLogDate: 'Data spawania',
      productNumber: 'Numer produktu',
      weldLength: 'Długość spawania (mm)',
      designation_1: 'Część 1 Oznaczenie',
      designation_2: 'Część 2 Oznaczenie',
      thickness_1: 'Grubość 1 (mm)',
      thickness_2: 'Grubość 2 (mm)',
      weld_diameter: 'Średnica spawania (mm)',
      notAccepted: 'Nie zaakceptowany',
      ndtStatus: 'Stan ndt',
      isDiameter: 'Czy średnica?',
      ndt: '%NDT',
      weldingCompound: 'Związek spawalniczy',
      batch_lot: 'Batc/lot',
      choose: 'Wybierać',
      pipe_description: 'Opis rury'
    },
    whsDashboard: {
      scanText: 'Zeskanuj numer zamówienia lub kod kreskowy',
      customerOrder: 'Zamówienia klientów',
      receiveSupplierOrder: 'Otrzymane zamówienia od dostawców',
      adjustmentOrders: 'Zamówienia korekty',
      transferOrders: 'Polecenia przelewu',
      cycleCount: 'Liczenie cykli',
      product: 'Produkt',
      supplierOrder: 'Zamówienie dostawcy',
      returnOrder: 'Zamówienie zwrotu'
    },
    ccsheet: {
      warehouse: 'Magazyn',
      created: 'Utworzono',
      counted: 'Policzone',
      count: 'Liczenie',
      reCount: 'Przeliczenie',
      closeComplete: 'Zamknij i zakończ',
      unit: 'Jednostka',
      stock: 'Zapasy',
      scanLocation: 'Zeskanuj lub wprowadź lokalizację',
      nextLoc: 'Następna lokalizacja',
      info: 'Wiadomość!',
      continueCount: 'Kontynuuj liczenie',
      clearAndRecount: 'Wyczyść i policz ponownie',
      completeRecount: 'Zakończ ponowne liczenie',
      ccsheetComplete: 'CCSheet zostanie ukończony. Kontynuować?',
      noSheetFound: 'Nie znaleziono arkusza CCSheet!',
      noProductOnLocation: 'Nie znaleziono żadnego produktu w tej lokalizacji!',
      stockTake: 'Przeprowadzono już inwentaryzację dla wybranej lokalizacji. Czy chcesz kontynuować liczenie w tej lokalizacji, czy wyczyścić dane i przeprowadzić nową inwentaryzację?',
      ccsheetAddProduct: 'Produkt nie został dodany do tego arkusza CCSheet, czy chcesz go dodać?'
    },
    product: {
      supplierartno: 'Numer artykułu dostawcy',
      supplier: 'Nazwa dostawcy',
      barcode: 'Kod kreskowy',
      noProductFound: 'Nie znaleziono produktu!',
      minQty: 'Min. ilość',
      orderQty: 'Zamówienie Ilość',
      qty: 'Ilość',
      batch: 'Partia',
      scanLoc: 'Wybierz lokalizację',
      noLocFound: 'Nie znaleziono lokalizacji!'
    },
    order: {
      products: 'Produkty',
      avail: 'Dostępne',
      pickProducts: 'Wybierz produkty',
      ordered: 'Ord.',
      received: 'Rec.',
      pickedQty: 'Pic.',
      pickOrder: 'Zamówienie',
      delivery: 'Del',
      rest: 'Odpoczynek',
      complete: 'Zakończ',
      pick: 'Pobierz',
      scanProduct: 'Zeskanuj kod kreskowy produktu',
      scanBatch: 'Zeskanuj numer partii',
      picked: 'Wybrano',
      toPick: 'Do pobrania',
      location: 'Lokalizacja',
      pickLocation: 'Wybierz lokalizację',
      qtyExceeds: 'Ilość przekracza',
      noOrderFound: 'Nie znaleziono zamówienia!',
      notValidBatch: 'Numer partii jest nieprawidłowy!',
      receiveOrder: 'Przyjmij zamówienie',
      receive: 'Odbierz',
      batchExists: 'Numer partii już istnieje!',
      receiveWarning: 'Czy chcesz dodać {qty} sztuk {product} do magazynu?',
      completedSuccess: 'Zakończono pomyślnie!',
      addFreight: 'Czy chcesz dodać fracht?',
      cost: 'Koszt',
      price: 'Cena',
      orderedQtyHigh: 'Otrzymana ilość jest wyższa niż zamówiona, czy chcesz kontynuować?',
      collect: 'Odbierz',
      receiving: 'Odbiór',
      availableToPick: 'Dostępna ilość do odbioru',
      adjust: 'Dostosuj',
      orderComplete: 'Zamówienie zostanie zrealizowane. Kontynuować?',
      orderDate: 'Data zamówienia'
    },
    tasks: {
      forYour: 'Dla Ciebie',
      information: 'Informacje',
      acknowledge: 'Potwierdź',
      review: 'Przeglądaj',
      approval: 'Zatwierdzenie',
      subject: 'Temat',
      dueDate: 'Termin',
      approve: 'Zatwierdzić',
      disapprove: 'Nie zatwierdzić',
      keep: 'Zachowaj',
      remove: 'Usuń'
    },
    mixed: {
      scanSerialNumber: 'Zeskanuj numer seryjny',
      noEquipmentFound: 'Nie znaleziono sprzętu',
      checklistfiles: 'Pliki listy kontrolnej',
      sharedUrl: 'Udostępniony adres URL',
      attachments: 'Załączniki',
      signature: 'Podpis',
      nochecklists: 'Brak list kontrolnych',
      checklistName: 'Lista kontrolna Nazwa',
      noOfDocuments: 'Liczba dokumentów',
      documentTitle: 'Tytuł dokumentu',
      qrCode: 'Kod QR',
      irscanner: 'Skaner IR',
      qrQty: 'Ilość QR',
      scanQRCode: 'Skanuj kod QR',
      attachmentsBelow: 'Znajdź załączniki poniżej',
      noChemicalFound: 'Nie znaleziono listy substancji chemicznych',
      barCodeNotDecoded: 'Nie udało się odszyfrować kodu kreskowego z kodu QR.',
      scanBarcode: 'Skanuj kod kreskowy'
    },
    chemicallist: {
      chemical: 'Chemiczny',
      provider: 'Dostawca',
      repository: 'Magazyn',
      last_revised: 'Ostatnio przeglądane',
      viewChemical: 'Chemiczny',
      chemicalName: 'Nazwa chemiczna'
    },
    news: {
      news: 'Wiadomości',
      next: 'Następ',
      previous: 'Poprzedni'
    },
    // Production series (WIT-PROTO-PRODSERIES-PWA-001). Copy mirrors the
    // backend's resources/lang/pl/production_series.php (key in comment).
    productionSeries: {
      idModeSpool: 'Spool/part no.', // id_mode_spool
      idModeSeq: 'Without spool/part no. — sequence number', // id_mode_seq
      seriesOf: 'Series', // series_of
      nWelds: '{n} welds', // n_welds
      hasProductionData: 'Has production data', // has_production_data
      unitsWelds: '{units} units · {welds} welds', // units_welds
      unitRetainedSuffix: ' · retained', // unit_retained_suffix
      markerDone: '{done}/{total} welded', // marker_done
      noUnit: 'no spool/part no.' // Decision B tag (task copy)
    },
    weldMapping: {
      // 5183 / S18: one batch/heat per welding method.
      methodBatchesLabel: 'Partia / wytop na metodę',
      methodBatchesHint: 'Ta spoina wykorzystuje więcej niż jedną metodę spawania. Zapisz partię użytą dla każdej z nich.',
      // 5183 / S4: production-series units under a drawing.
      unitsHeading: 'Numery spool / części',
      unitScoped: 'Pokazano spool {unit}',
      unitShowAll: 'Pokaż wszystkie',
      unsavedHint: 'Niezapisane zmiany — użyj przycisku poniżej, aby je odrzucić',
      batchMissing: 'Partia/wytop niezarejestrowany — podaj przed zakończeniem',
      supersededBy: 'Zastąpiona przez {weld} — zarejestruj naprawę na tej spoinie',
      previewWps: 'Podgląd WPS',
      comment: 'Komentarz',
      copyMaterial: 'Kopiuj materiał',
      vtRejectedOn: 'VT odrzucone na',
      by: 'przez',
      reason: 'Powód:',
      repairOf: 'Naprawa',
      wireBatchTitle: 'Drut spawalniczy · partia/wytop',
      batchPf: 'Partia spoiwa spawalniczego',
      batchPfHint: 'Zeskanuj lub wpisz partię…',
      assemblyPf: 'Certyfikat montażu (PF) (opcjonalnie)',
      weldCertificate: 'Certyfikat spawacza',
      certGroupQualified: 'Kwalifikowany',
      certGroupCannotVerify: 'Nie można zweryfikować',
      certGroupNotQualified: 'Niekwalifikowany',
      certNoneQualified: 'Brak kwalifikujących certyfikatów dla tej spoiny',
      certLockedTitle: 'Spoina zablokowana — brak certyfikatu',
      certLockedMsg: 'Nie masz certyfikatu kwalifikującego do tej spoiny. Skontaktuj się z koordynatorem spawania.',
      certAdvisoryTitle: 'Certyfikat niepotwierdzony',
      certAdvisoryMsg: 'Żadnego z Twoich certyfikatów nie udało się potwierdzić dla tej spoiny. Możesz podpisać — wybór zostanie zapisany przy spoinie.',
      // WIT-FIX-CERT-5348-001 F5a: the advisory is a not_qualified finding, not cannot_verify.
      certNotQualifiedTitle: 'Brak certyfikatu obejmującego spoinę',
      // WIT-FIX-CERT-5355-001 F5a / D-5355-3 (Erik 15.10): what none of the welder's certificates covers, then how to go on.
      certNotQualifiedMsg: 'Żaden z Twoich certyfikatów nie obejmuje tej spoiny{codes}. Możesz podpisać z uzasadnieniem — koordynator spawania je zobaczy.',
      certNotQualifiedLead: 'Żaden z Twoich certyfikatów nie obejmuje tej spoiny.',
      certSignWithReasonHint: 'Możesz podpisać z uzasadnieniem — koordynator spawania je zobaczy.',
      certReasonWelder: 'Napisz krótko, dlaczego podpisujesz bez kwalifikującego certyfikatu (np. „certyfikat jeszcze niezarejestrowany”). Koordynator spawania zobaczy uzasadnienie w dzienniku spawania.',
      certNoValidMsg: 'Nie masz ważnego certyfikatu spawacza dla tej spoiny. Możesz podpisać — spoina zostanie oznaczona dla koordynatora spawania.',
      certMissingProcess: ' (brak metody {codes})',
      // F2: the office override on the sheet (server weld_mapping.cert_ui.override_tip_* twins).
      certOverrideTipReason: 'Powód: {reason}',
      certOverrideTipBy: 'Kto: {by}',
      certOverrideTipAt: 'Kiedy: {at}',
      certAutoHint: 'Wybierany automatycznie spośród Twoich ważnych certyfikatów po naciśnięciu «Spawanie zakończone».',
      certConfirmTitle: 'Potwierdź certyfikat',
      certConfirmBtn: 'Potwierdź',
      // WIT-FIX-RETEST-1008-001 P-C: under the confirm intro, only for «Kan ikke verifiseres».
      certConfirmManualNote: 'Your choice is marked «Confirmed manually» and shown to the welding coordinator.',
      // P-C: the chip for a welder's own confirmation (cert_verdict cannot_verify_confirmed).
      certVerdictConfirmed: 'Potwierdzono ręcznie',
      // P-D: the stop under «Blokker» when nothing the welder holds can apply.
      certBlockedTitle: 'The weld cannot be registered',
      certOverrideTitle: 'Brak certyfikatu obejmującego spoinę',
      certOverrideBlock: 'Projekt wymaga uprawniającego certyfikatu. Podaj uzasadnienie, aby mimo to podpisać — koordynator spawania zobaczy je w dzienniku spawania.',
      certOverrideWarn: 'Spoina zostanie podpisana i oznaczona dla koordynatora spawania. Możesz dodać uzasadnienie.',
      certReasonLabel: 'Uzasadnienie',
      certReasonRequired: 'Uzasadnienie jest wymagane.',
      // WIT-FIX-WELDMAP-002 (3.4 / 3.5) — needs native review
      certRankedTitle: 'Twoje certyfikaty dla tej spoiny:',
      welderIdMissing: 'Brak ID spawacza',
      welderIdMissingHint: 'Podpisano bez ID spawacza — dodaj ID spawacza w swoim profilu użytkownika.',
      certSignBtn: 'Podpisz',
      certLockedOverride: 'Możesz podpisać z uzasadnieniem — koordynator spawania je zobaczy.',
      certVerdictQualified: 'Kwalifikowany',
      certVerdictUnverified: 'Niezweryfikowany',
      certVerdictNotQualified: 'Niekwalifikowany',
      certVerdictNotChecked: 'Niesprawdzone',
      // WIT-IMPL-CERT-001 P2/P3
      certVerdictOverride: 'Nadpisany',
      certFlaggedToast: 'Podpisano i oznaczono dla koordynatora spawania.',
      undoSign: 'Cofnij podpis',
      undoSignDone: 'Podpis spoiny {weld} został cofnięty.',
      // WIT-IMPL-CERT-001 P4 (office picker)
      certShowAllWelders: 'Pokaż wszystkich spawaczy w firmie',
      certNonParticipant: 'nie uczestniczy w projekcie',
      certNonParticipantReason: 'Spawacz nie uczestniczy w projekcie. Podaj uzasadnienie — wybór zostanie zapisany jako nadpisanie.',
      noServerAnswer: 'Brak odpowiedzi serwera. Sprawdź połączenie i spróbuj ponownie — nic nie zostało zapisane.',
      certMatchChecking: 'Sprawdzanie certyfikatów…',
      // WIT-FIX-PWA-WELDERCERT-001 (Erik 09.10.2026): the welder's own picker.
      certAutoPick: 'Wybierany automatycznie · {n} pasujących',
      certOwnHeading: 'Twoje pasujące certyfikaty',
      certOwnHidden: 'Ukryte: {n} Twoich certyfikatów nie obejmuje metody / typu spoiny.',
      certNoCertificates: 'Nie masz zarejestrowanego certyfikatu spawacza. Skontaktuj się z koordynatorem spawania.',
      certNoneRelevant: 'Nie masz certyfikatu kwalifikującego do spoiny {weld}. Skontaktuj się z koordynatorem spawania.',
      assemblyPfHint: 'Wybierz certyfikat …',
      search: 'Szukaj',
      nSelected: 'wybrano {n}',
      assemblyPfNone: 'Brak dostępnych certyfikatów',
      batchPfRequired: 'Podaj partię spoiwa, aby zakończyć montaż',
      required: 'wymagane',
      rejectWhy: 'Dlaczego złącze jest odrzucone?',
      rejectNote: 'Uwaga (opcjonalnie)',
      vtLevelIso: 'Poziom VT (ISO 5817)',
      vtLevelFromWeld: 'Ustawiony na spoinie',
      vtLevelOverriding: 'Zmiana poziomu',
      vtLevelNotSet: 'Nie ustawiono',
      vtLevels: {
        B: 'Surowy',
        C: 'Średni',
        D: 'Umiarkowany'
      },
      faults: {
        undercut: 'Podtopienie',
        porosity: 'Porowatość',
        spatter: 'Odpryski',
        fusion: 'Brak przetopu',
        geometry: 'Geometria',
        other: 'Inne'
      },
      uploading: 'Przesyłanie…',
      photoSaved: 'Zdjęcie zapisane',
      fromWps: 'z WPS',
      change: 'Zmień',
      batchCharge: 'Partia / nr wytopu',
      batchChargeHint: 'Wybierz partię …',
      batchAdd: 'Dodaj',
      batchAddNew: '+ Dodaj nową partię …',
      batchGroupWps: 'Dla tej WPS',
      batchTypeNew: 'Inna… (wpisz nową partię)',
      batchPickFromList: 'Wybierz z listy',
      takePhoto: 'Zrób zdjęcie',
      uploadPhoto: 'Wgraj zdjęcie',
      signedAs: 'Podpisano Twoim użytkownikiem',
      title: 'Mapowanie spoin',
      featureDisabled: 'Nie masz dostępu do Mapowania spoin.',
      searchDrawing: 'Szukaj rysunku',
      continue: 'Kontynuuj',
      lastOpened: 'Ostatnio otwarte',
      allDrawings: 'Wszystkie rysunki',
      childDrawings: 'Rysunki podrzędne',
      welds: 'spoiny',
      hasChildren: '{count} rysunków podrzędnych',
      noMatch: 'Brak pasujących rysunków',
      noMatchHint: 'Spróbuj innego numeru rysunku.',
      mapComingNext: 'Mapa spoin otworzy się tutaj w następnym kroku.',
      drawingsShort: 'Rysunki',
      prevDrawing: 'Poprzedni rysunek: {number}',
      nextDrawing: 'Następny rysunek: {number}',
      firstDrawing: 'Pierwszy rysunek',
      lastDrawing: 'Ostatni rysunek',
      ownJoints: 'Własne spoiny',
      ownMap: 'Otwórz mapę spoin dla {number}',
      ownSub: '{count} spoin na samym rysunku',
      joints: 'Spoiny',
      toggleJoints: 'Pokaż lub ukryj listę spoin',
      noJoints: 'Brak spoin na tym rysunku',
      // Which STAGE a drawing has reached (D-5170-1).
      drawingStage: {
        pending: 'Not started',
        mapping: 'Being mapped',
        mapped: 'Mapped',
        welding: 'Being welded',
        ndt: 'Awaiting inspection',
        // «VT fullført» (WIT-IMPL-PWA-DRAWINGSTATUS-003): alt sveist og VT
        // signert, men en annen påkrevd NDT-metode gjenstår.
        vt_done: 'VT zakończone',
        done: 'Complete'
      },
      status: {
        MAPPED: 'Zmapowane',
        FITTED: 'Złożone',
        WELDED: 'Spawane',
        COMPLETED: 'Ukończone',
        REPAIR: 'Naprawa'
      },
      wps: 'WPS',
      process: 'Metoda',
      filler: 'Spoiwo',
      vtLevel: 'Poziom VT',
      trace: 'Identyfikowalność',
      fittedBy: 'Złożone przez',
      weldedBy: 'Spawane przez',
      vtBy: 'VT przez',
      batch: 'partia',
      wire: 'drut',
      level: 'poziom',
      vtRejectedBy: 'VT odrzucone przez',
      vtPending: 'Oczekuje na kontrolę VT',
      field: {
        title: 'Field-registered weld',
        legend: 'Field-registered (awaiting office)',
        addBtn: 'Add weld in field',
        placeHint: 'Tap the drawing where the new weld goes',
        cancel: 'Cancel',
        queued: '{n} registration(s) waiting for connection',
        syncNow: 'Sync now',
        wpsDeviation: 'WPS deviation',
        newTitle: 'New weld – field-registered',
        editTitle: 'Edit field-registered weld',
        newSub: 'Registered by the welder on site and flagged for review by the office.',
        loadingOptions: 'Loading registers…',
        after: 'After weld',
        weldNr: 'Weld no.',
        idHint: 'Letter + the preceding weld\'s number: the first between W-0005 and W-0006 becomes A-0005, then B-0005, C-0005 …',
        reason: 'Reason',
        pickReason: 'Choose reason…',
        pick: 'Choose…',
        joint: 'Joint',
        groove: 'Groove type',
        pickGroove: 'Choose groove type…',
        pickJointFirst: 'Choose joint first',
        pickWps: 'Choose WPS…',
        material: 'Base material',
        materialsFailed: 'The material register could not be loaded. Try again, or tell the office.',
        thickness: 'Thickness (mm)',
        weldLength: 'Length mm',
        spool: 'Spool/part no.',
        pickSpool: 'Select spool/part no.…',
        spoolHint: 'This drawing has several spool/part numbers — pick the one this weld is on.',
        validRange: 'valid {min}–{max} mm',
        warnNotBlocking: 'The weld can be saved, but the deviation is flagged to the office.',
        warnMaterial: 'Material {material} is not covered by {wps}.',
        warnThickness: 'Thickness {t} mm is outside the WPS validity range ({min}–{max} mm).',
        // WIT-IMPL-WPS-5324-003 (F4): weld_mapping.field_wps_no_process twin.
        warnNoProcess: 'WPS {wps} nie ma metody spawania – certyfikatu nie można zweryfikować.',
        optional: 'optional',
        notePh: 'E.g. location, deviation, reference…',
        save: 'Save weld',
        registeredToast: '{weld} registered — sent to the office for review',
        queuedToast: '{weld} saved on the device — sent to the office when back online',
        updated: '{weld} updated',
        registered: 'Registered',
        reviewComment: 'Comment from the office',
        office: 'Office',
        approve: 'Approve',
        reject: 'Reject',
        remove: 'Remove from drawing',
        edit: 'Edit registration',
        rejectedNote: 'Rejected by the office — remove it or register the weld again.',
        localPending: 'Waiting for connection — not yet sent to the office.',
        delete: 'Delete registration',
        deleteConfirm: 'Delete {weld}? The registration is removed from the drawing and the weld log.',
        deleteHasData: 'The weld has production data ({status}) and cannot be deleted here.',
        decision: {
          rejected: 'Rejected by the office',
          approved: 'Approved by the office'
        },
        notifications: 'Notifications',
        noNotifications: 'No notifications',
        status: {
          pending: 'Field-registered',
          approved: 'Approved',
          rejected: 'Rejected'
        },
        sub: {
          pending: 'awaiting office approval',
          approved: 'field-registered · approved',
          rejected: 'rejected by the office',
          local: 'waiting for sync'
        },
        reasons: {
          missed_in_mapping: 'Missed in mapping',
          unforeseen_pipe_joint: 'Unforeseen pipe joint',
          site_change: 'Site change',
          other: 'Other'
        },
        joints: {
          BW: 'BW – Butt weld',
          FW: 'FW – Fillet weld',
          'BW-ROR': 'BW – Pipe joint'
        },
        grooves: {
          V: 'V-groove',
          X: 'X-groove',
          I: 'I-groove',
          U: 'U-groove',
          HV: 'HV-groove',
          J: 'J-groove',
          FILLET_A: 'Fillet (a-dimension)'
        },
        notif: {
          field_weld_registered: '{weld} registered in the field — review needed',
          field_weld_approved: '{weld} approved by the office',
          field_weld_rejected: '{weld} rejected by the office'
        }
      },
      // WIT-IMPL-M101-PWA-001: read-only NDT context per joint (server-derived)
      // and the hold-welding warning carrier. Never a block.
      ndtContext: {
        title: 'NDT context',
        classDefault: 'Class',
        classM101: 'Inspection category (NORSOK N-004)',
        classM601: 'NDT group (NORSOK M-601 table 2)',
        jointType: 'Joint type',
        weldType: 'Weld type',
        penDepth: 's (mm)',
        holdTime: 'Hold time before NDT',
        earliestNdt: 'Earliest NDT',
        pending: 'To be clarified',
        status: 'Status',
        hold: {
          pwht: 'none (NDT after PWHT)',
          default_48: '48 h',
          smys_le_355: '24 h (SMYS ≤ 355, documented)',
          smys_le_460_thin: '24 h (SMYS ≤ 460 and t < 40 mm, documented)',
          smys_missing: '48 h (yield strength missing)',
          thickness_missing: '48 h (thickness missing)',
          // WIT-FIX-M101-001: table G.1 fixed hold; no SMYS because the material is unlinked.
          g1_fixed_48: '48 h (10.1)',
          material_unlinked: '48 h – materiał nie jest powiązany z materiałem standardowym',
          // WIT-IMPL-SVV-R761-002: NS-EN 1090-2 table 23 (SVV R761).
          table23: '{h} h (NS-EN 1090-2 tabela 23)',
          table23_cooling: 'tylko chłodzenie (tabela 23)',
          table23_pending: 'do wyjaśnienia (tabela 23)',
          drawing: '{h} h (drawing)',
          default: '{h} h',
          none: 'none registered'
        }
      },
      weldingHold: {
        flag: 'Welding hold',
        wps: 'Welding hold on WPS {wps}',
        welder: 'Welding hold for the welder',
        since: 'since {date}',
        notBlocking: 'Warning – the weld can be registered, the office has been notified.'
      },
      pendingSync: 'Oczekuje na synchronizację',
      noSymbol: 'Brak symbolu',
      noExecution: 'Brak zarejestrowanego wykonania',
      close: 'Zamknij',
      noDrawingFile: 'Nie przesłano rysunku',
      noPreview: 'Podgląd niedostępny',
      imageFailed: 'Nie można załadować obrazu rysunku',
      roles: {
        fitter: 'Ślusarz',
        welder: 'Spawacz',
        vt: 'Kontrola VT'
      },
      hints: {
        fitter: '{n} spoin czeka na złożenie',
        fitterDone: 'Wszystkie złożenia gotowe!',
        welder: '{n} gotowych do spawania',
        welderNone: 'Brak gotowych — czeka na złożenie',
        welderNdt: 'Wszystkie spoiny wykonane — {n} czeka na badania NDT',
        welderDone: 'Wszystkie spoiny wykonane i sprawdzone!',
        vt: '{n} czeka na kontrolę VT',
        vtDone: 'Nic nie czeka na VT — wszystko sprawdzone!',
        vtNdtOpen: '{n} zatwierdzonych VT — oczekuje na pozostałe badania NDT (podpisywane w wersji web)',
        loading: 'Wczytywanie spoin…'
      },
      materials: 'Identyfikowalność materiału',
      heat: 'Wytop/partia',
      heatMissing: 'Brak wytopu',
      bulkFitUp: 'Zmontowano',
      bulkWeldEnd: 'Zespawano',
      bulkWeldList: 'Podpisuje te spoiny',
      changeHistory: 'Historia zmian',
      auditField: {
        fillerBatch: 'Partia spoiny',
        batchPf: 'Partia montażowa',
        filler: 'Spoiwo',
        certificateRefs: 'Certyfikat spawania',
        assemblyPf: 'Certyfikat montażu',
        vtLevel: 'Poziom VT',
        // WIT-FIX-CERT-5348-001 F2: the certificate decision in Endringslogg.
        certVerdict: 'Kontrola certyfikatu',
        certOverrideReason: 'Powód nadpisania',
        certUnqualifiedSign: 'Podpisano bez uprawniającego certyfikatu',
        traceabilityGaps: 'Podpisano z brakującą identyfikowalnością',
        certRegisteredLater: 'Certyfikat zarejestrowany później'
      },
      auditFrom: 'Z',
      auditTo: 'Na',
      auditNoChange: 'Zapisano bez zmian',
      auditAction: {
        add: 'Dodano',
        flag: 'Oznaczono',
        update: 'Zmieniono',
        delete: 'Usunięto'
      },
      posLabel: 'Poz.',
      posNrMissing: 'Brak nr poz.',
      noMaterials: 'Brak materiałów w planie',
      addMaterial: 'Dodaj',
      fillAllMaterials: 'Uzupełnij wszystkie',
      fillAllHint: 'Typ materiału, heat, grubość i poz. dla wszystkich materiałów tej spoiny. Zapisywane są tylko zmienione wiersze.',
      newMaterial: 'Nowy materiał',
      editMaterial: 'Edytuj materiał',
      materialHint: 'Zeskanuj oznaczenie na stali lub wpisz ręcznie.',
      scanQr: 'Skanuj etykietę (QR)',
      scanNfc: 'RFID/NFC',
      scanComingNext: 'Skanowanie w kolejnym kroku — wpisz ręcznie poniżej',
      orManual: 'LUB WPISZ RĘCZNIE',
      materialType: 'Typ materiału',
      selectType: 'Wybierz typ materiału',
      editFieldHint: 'Zapisywane są tylko zmienione pola. Podpis, data i VT pozostają bez zmian.',
      noTypeMatches: 'Brak wyników',
      noTypesInRegister: 'Brak typów materiałów w rejestrze',
      heatNo: 'Nr wytopu',
      heatTypeNew: 'Inny… (wpisz nowy nr wytopu)',
      heatFromMaterialList: 'Z listy materiałów',
      thickness: 'Grubość (mm)',
      posNo: 'Nr pozycji',
      saveChanges: 'Zapisz zmiany',
      gapWarnTitle: 'Brakujące dane',
      gapWarnHint: 'W identyfikowalności materiału brakuje danych. Podpisać mimo to?',
      gapWarnYes: 'Tak, podpisz mimo to',
      gapWarnNo: 'Nie, uzupełnij teraz',
      gapThickness: 'brak grubości',
      gapType: 'brak typu materiału',
      gapRow: 'Wiersz {n}',
      bulkSignVt: 'Zatwierdź VT wszystkie {n}',
      bulkConfirm: 'Potwierdź',
      bulkTitleVt: 'Zatwierdź VT wszystkie gotowe spoiny',
      bulkHint: 'Zatwierdza {n} spoin oczekujących na VT na tym rysunku. Brakujące dane zostaną pokazane później.',
      bulkSigned: 'podpisano: {n}',
      bulkSkipped: 'pominięto: {n}',
      bulkGapsTitle: 'Braki w identyfikowalności',
      bulkGapsHint: 'W tych spoinach brakuje danych. Możesz zatwierdzić mimo to lub anulować i najpierw je uzupełnić.',
      gapHeat: 'brak numeru wytopu',
      gapPosNr: 'brak nr pozycji',
      gapNoMaterials: 'brak materiałów',
      cancel: 'Anuluj',
      removeMaterial: 'Usuń materiał',
      removeMaterialConfirm: 'Usunąć materiał {n}? Zostanie od razu usunięty z tej spoiny.',
      saving: 'Zapisywanie…',
      repairNote: 'VT odrzuciło tę spoinę — napraw i zarejestruj ponownie.',
      actFitUp: 'Złożenie wykonane',
      actWeld: 'Spawanie zakończone',
      actRepair: 'Naprawione i zespawane',
      actVtOk: 'VT zatwierdzone — poziom {level}',
      actVtReject: 'Odrzuć — wyślij do naprawy',
      actionsComingNext: 'Rejestracja zostanie podłączona w następnym kroku',
      vtSignedNdtOpen: 'VT zatwierdzone — pozostałe NDT w toku',
      noAction: 'Brak działania {role} dla tej spoiny ({status})'
    },
    advancedWeldLog: {
      // 5183 / R-2.7c: the production-series column in the weld list.
      spoolNo: 'Nr spool / części',
      // 5183 / R-2.7d: route to the weld-mapping screen, where the flow lives.
      addFieldWeld: 'Dodaj spoinę w terenie',
      noDrawingsFound: 'Nie znaleziono rysunków',
      folderLIst: 'Lista folderów',
      projectDrawings: 'Rysunki projektowe',
      drawingNumber: 'Numer rysunku',
      weldCount: 'Liczba spoin',
      engineering: 'Inżynieria',
      production: 'Produkcja',
      ndt: 'NDT',
      pending: 'Oczekujące',
      inProgress: 'W trakcie',
      completed: 'Zakończone',
      ndtFaultScope: 'Zakres usterek NDT',
      submit: 'Zatwierdź',
      cancel: 'Anuluj',
      newWeldLog: 'Dziennik spoin',
      updateWeldLog: 'Aktualizuj dziennik',
      weldNo: 'Numer spoiny',
      jointType: 'Typ złącza',
      wps: 'WPS',
      weldingConsumables: 'Materiały spawalnicze',
      batchNumber: 'Heat / Batch nr',
      welderCertificates: 'Certyfikaty spawaczy',
      weldEnd: 'Koniec spoiny',
      ok: 'Ok',
      sign: 'Podpisz',
      comments: 'Komentarze',
      notAcceptable: 'Nieakceptowalne',
      fault: 'Usterka',
      noResultsFound: 'Nie znaleziono wyników.',
      drawing: 'Rysunek',
      projectName: 'Nazwa projektu',
      aoRanked: 'AO oceniony',
      poRanked: 'PO oceniony',
      searchWeldLogs: 'Szukaj dzienników spoin',
      confirmWeldLogDelete: 'Czy na pewno chcesz usunąć spoinę {weld_nr}?',
      weldingProcess: 'Proces spawania',
      ndts: 'NDT-y',
      searchDrawings: 'Szukaj rysunków',
      selectDrawing: 'Wybierz rysunek',
      noWeldLogResultsFound: 'Nie znaleziono dzienników spoin!',
      selectDrawingToLoadWeldLogs: 'Wybierz rysunek, aby załadować dzienniki!',
      certificateRequiredWhenWeldEnd: 'Certyfikat jest wymagany, gdy wybrano Koniec spoiny.'
    }
  }
}
